import { Rule } from 'antd/lib/form';
import DateInput from 'components/DateInput/DateInput';
import moment from 'moment';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IScheduleField {
	schedule: string;
	changeSchedule: (value: string) => void;
}

const ScheduleField: React.FC<IScheduleField> = ({ schedule, changeSchedule }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterSchedule') },
			() => ({
				validator() {
					const now = moment();
					const selectedDate = moment(schedule);
					if (selectedDate > now) {
						return Promise.resolve();
					}
					return Promise.reject(new Error(t('mustBeFutureDate')));
				},
			}),
		],
		[t, schedule],
	);

	return (
		<DateInput
			testId="ScheduleField"
			label="scheduleLabel"
			name="schedule"
			getRawFormat={true}
			resetSeconds={true}
			onChange={changeSchedule}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(ScheduleField);
